import { Injectable } from '@angular/core';
import { CssStyles } from '../models/css-styles-model';

@Injectable({
  providedIn: 'root',
})
export class StyleCalculatorService {
  constructor() {}

  calculateStyles(width: number, model: CssStyles) {
    if (!model.viewports || !model.viewports.length) {
      return { ...model };
    }
    const viewportSortedModels = model.viewports
      .filter(v => v.width <= width)
      .sort((a, b) => b.width - a.width);
    if (!viewportSortedModels || !viewportSortedModels.length) {
      return { ...model };
    }

    const overrideModel = viewportSortedModels[0].styles;

    let baseModel = { ...model };

    Object.keys(overrideModel).forEach(key => {
      baseModel[key] = overrideModel[key];
    });

    return baseModel;
  }
}
